/**
 * Administration management page.
 * DynamicRoleGroup wrapper for the admins role group.
 */

import * as React from 'react';
import { DynamicRoleGroupManagementPage } from '@/components/common/DynamicRoleGroupManagementPage';
import { ADMIN_TAB_COLORS } from '@/components/admins/admin-configs';

/** Thin wrapper around {@link DynamicRoleGroupManagementPage} for the admins role group. */
export const AdminsManagementPage: React.FC = () => (
  <DynamicRoleGroupManagementPage
    interfaceName="admins"
    menuId="menu-admins"
    title="Administration"
    subtitle="Créez, modifiez et gérez tous vos collaborateurs"
    createLabel="Créer un collaborateur"
    userQueryKey="admin"
    allTabColor={ADMIN_TAB_COLORS.all}
  />
);
